<template>
  <ul class="auth-tabs" role="tablist">
    <li role="presentation" class="auth-tab" :class="{ active: active === 'login' }">
      <b-link role="tab" :aria-selected="active === 'login' ? 'true' : 'false'" to="/login">
        НЭВТРЭХ
      </b-link>
    </li>
    <li role="presentation" class="auth-tab" :class="{ active: active === 'register' }">
      <b-link role="tab" :aria-selected="active === 'register' ? 'true' : 'false'" to="/registration">
        БҮРТГҮҮЛЭХ
      </b-link>
    </li>
  </ul>
</template>

<script>
export default {
  name: "AuthTabs",
  props: {
    active: {
      type: String,
      required: true,
      validator: (value) => ["login", "register"].includes(value),
    },
  },
};
</script>

<style scoped>
.auth-tabs {
  display: flex;
  justify-content: center;
  gap: 12px;
  list-style-type: none;
  width: 100%;
  max-width: 400px;
  margin: 0 auto;
  padding: 0 16px;
  border-bottom: 1px solid #f39c12;
}
.auth-tab {
  flex: 1;
}
.auth-tab a {
  display: block;
  text-align: center;
  padding: 8px 16px;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  background-color: #fdf8f1;
  color: #e67e22;
  font-weight: 500;
  text-decoration: none;
}
.auth-tab a:hover,
.auth-tab a:focus {
  background-color: #fdf8f1;
  text-decoration: none;
}
.auth-tab.active a {
  background-color: #f39c12;
  color: #ffffff;
}
.auth-tab.active a:hover,
.auth-tab.active a:focus {
  background-color: #f39c12;
}
</style>
